var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$getConstRole('ROLE_CLIENT') == _vm.role)?_c('ClientInvoice'):_vm._e(),(_vm.$getConstRole('ROLE_AGENT') == _vm.role)?_c('AgentInvoice'):_vm._e(),(_vm.$getConstRole('ROLE_ACCOUNTING') == _vm.role)?_c('AccountantInvoice'):_vm._e(),(_vm.$getConstRole('ROLE_ADMIN') == _vm.role)?_c('AdminInvoice'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }